import gql from 'graphql-tag';

import jobCopyIntegrationItemFragment from '../fragments/jobCopyIntegrationItemFragment';

export const queryJobCopyIntegrationItem = gql`
  query jobCopyIntegrationItem($id: DokkioID!) {
    jobCopyIntegrationItem(id: $id) {
      ...jobCopyIntegrationItemFragment
    }
  }
  ${jobCopyIntegrationItemFragment}

`;
export default queryJobCopyIntegrationItem;
